import { IReportService } from "../../service/report/ReportService";

export default class GetReport1FormVersionListInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(
    reportingPeriodId: number,
    applicantId: number,
    formVersionId: number
  ) {
    return this.reportService.getFormVersionsList(
      reportingPeriodId,
      applicantId,
      formVersionId
    );
  }
}
